import detailStyles from '../ChallengeDetail.module.scss';
import image61 from './images/6-1.jpg';
import image82 from './images/8-2.jpg';
import image83 from './images/8-3.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const UpgradeWorkDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Офис»</b>
                </div>
                <ChallengeDetailHelpImage image={image61} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Нажмите кнопку <b>«Улучшения»</b>
                </div>
                <ChallengeDetailHelpImage image={image82} helpText='Это картинка. Ищите кнопку в разделе «Офис».' />
            </p>
            
            <p>
                <div>
                    Улучшите любые характеристики 3 раза
                </div>
                <ChallengeDetailHelpImage image={image83} helpText='Это картинка. Ищите кнопку в списке улучшений.' />
            </p>
        </div>
    );
}